export const defaultWithdrawAnswer =
  '안녕하세요. 입력해주신 계좌번호가 회원님 성함과 일치하지 않아 입금을 해드리지 못하고 있습니다. 입금받으실 정확한 계좌번호를 [1:1문의하기]에 다시 남겨주시면 감사하겠습니다.';
